import  { useEffect, useState, useCallback } from 'react';
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';
import 'datatables.net-buttons-dt/js/buttons.dataTables.js';
import 'jszip/dist/jszip.min.js';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Icon } from '@iconify/react/dist/iconify.js';
// import { LoginContext } from "../AuthContext/LoginContext";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import axios from 'axios';
import TooltipTextPopupCustom from './child/TooltipTextPopupCustom';

// Add CSS for sticky headers
const styles = `
  .table-responsive {
    max-height: 500px; /* Adjust height as needed */
    overflow-y: auto; /* Enable vertical scrolling */
  }
  .table.bordered-table thead th {
    position: sticky;
    top: 0;
    background-color: #fff; /* Ensure headers have a background */
    z-index: 10; /* Ensure headers stay above table body */
  }
  .table.bordered-table {
    width: 100%;
    border-collapse: collapse; /* Ensure proper table rendering */
  }
`;

const TableDataLayerVolunteers = () => {
    const [volunteers, setVolunteers] = useState([]);
    const [loading, setLoading] = useState(true);
    const API_BASE_URL = process.env.REACT_APP_BE_API_URL;
    

    const fetchVolunteers = useCallback(async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.get(`${API_BASE_URL}/backend/volunteers/get-all-volunteer`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.data.status) {
                setVolunteers(response.data.data);
            } else {
                toast.error("Failed to fetch volunteers.");
                console.error(response.data.message);
            }
        } catch (error) {
            console.error("Error fetching volunteers:", error);
            toast.error("Error fetching volunteers.");
        } finally {
            setLoading(false);
        }
    }, [API_BASE_URL]);

    useEffect(() => {
        fetchVolunteers();
    }, [fetchVolunteers]);

    useEffect(() => {
        let table;
        if (volunteers.length > 0 && !$.fn.DataTable.isDataTable('#dataTable')) {
            table = $('#dataTable').DataTable({
                dom: 'Bfrtip',
                buttons: [
                    {
                        extend: 'csv',
                        text: '<i class="iconify" data-icon="mdi:file-delimited-outline"></i> CSV',
                        className: 'btn btn-success btn-sm',
                        exportOptions: {
                            columns: function (idx, data, node) {
                                const skipColumnTitles = ['Photo', 'Video'];
                                const headerText = $(node).text().trim();
                                return !skipColumnTitles.includes(headerText);
                            }
                        }
                    },
                    'colvis'
                ],
                paging: false, // Disable pagination to show all rows
                responsive: true,
                destroy: true,
            });
        }

        return () => {
            if (table) {
                table.destroy();
            }
        };
    }, [volunteers]);

    const exportToCSV = () => {
        $('#dataTable').DataTable().button('.buttons-csv').trigger();
    };

    return (
        <div className="card basic-data-table">
            <style>{styles}</style> {/* Inject CSS for sticky headers */}
            <ToastContainer />
            <div className="card-header d-flex justify-content-between align-items-center">
                <div className="export-buttons d-flex align-items-center">
                    <button onClick={exportToCSV} className="btn btn-success btn-sm me-2 d-flex align-items-center">
                        <Icon icon="mdi:file-delimited-outline" className="me-1" style={{ fontSize: '16px' }} /> 
                        Download CSV
                    </button>
                </div>
            </div>
            <div className="card-body">
                <div className="table-responsive">
                    <table className="table bordered-table mb-0" id="dataTable">
                        <thead>
                            <tr>
                                <th scope="col">S.No.</th>
                                <th scope="col">Name</th>
                                <th scope="col">Email</th>
                                <th scope="col">Phone</th>
                                <th scope="col">CNIC</th>
                                <th scope="col">Gender</th>
                                <th scope="col">Skills</th>
                                <th scope="col">District</th>
                                <th scope="col">Tehsil</th>
                                <th scope="col">City</th>
                                <th scope="col">Address</th>
                                <th scope="col">Photo</th>
                                <th scope="col">Video</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                Array.from({ length: 10 }).map((_, index) => (
                                    <tr key={index}>
                                        <td><Skeleton width={30} /></td>
                                        <td><Skeleton width={120} /></td>
                                        <td><Skeleton width={150} /></td>
                                        <td><Skeleton width={100} /></td>
                                        <td><Skeleton width={100} /></td>
                                        <td><Skeleton width={80} /></td>
                                        <td><Skeleton width={100} /></td>
                                        <td><Skeleton width={100} /></td>
                                        <td><Skeleton width={100} /></td>
                                        <td><Skeleton width={100} /></td>
                                        <td><Skeleton width={150} /></td>
                                        <td><Skeleton width={100} /></td>
                                        <td><Skeleton width={100} /></td>
                                    </tr>
                                ))
                            ) : volunteers && volunteers.length > 0 ? (
                                volunteers.map((volunteer, index) => (
                                    <tr key={volunteer._id}>
                                        <td>{index + 1}</td>
                                        <td>{volunteer.name}</td>
                                        <td>{volunteer.email}</td>
                                        <td>{volunteer.phone}</td>
                                        <td>{volunteer.cnic}</td>
                                        <td>{volunteer.gender}</td>
                                        <td>{volunteer.skills?.length > 0 ? volunteer.skills.join(', ') : 'No Skills'}</td>
                                        <td>{volunteer.district}</td>
                                        <td>{volunteer.tehsil}</td>
                                        <td>{volunteer.city}</td>
                                        <td>
                                            <TooltipTextPopupCustom 
                                                text={volunteer.address}
                                                truncateLength={16} 
                                                placement="left"
                                                customClass="tooltip-info" />
                                        </td>
                                        <td>
                                            {volunteer.photoUrl ? (
                                                <button
                                                    className="btn btn-success-500 btn-sm w-100 h-100 d-flex align-items-center justify-content-center"
                                                    style={{ padding: '4px', fontSize: '12px' }}
                                                    onClick={() => window.open(volunteer.photoUrl, '_blank', 'noopener,noreferrer')}
                                                >
                                                    View Photo
                                                </button>
                                            ) : 'No Photo'}
                                        </td>
                                        <td>
                                            {volunteer.videoUrl ? (
                                                <button
                                                    className="btn btn-success-500 btn-sm w-100 h-100 d-flex align-items-center justify-content-center"
                                                    style={{ padding: '4px', fontSize: '12px' }}
                                                    onClick={() => window.open(volunteer.videoUrl, '_blank', 'noopener,noreferrer')}
                                                >
                                                    View Video
                                                </button>
                                            ) : 'No Video'}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="13" className="text-center">No volunteers found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default TableDataLayerVolunteers;